import type { ReactNode } from "react";
import { useChatComposer, useChatIsStreaming } from "../ChatContext";
import { BaseDropZone } from "../attachments/BaseDropZone";

export interface DropZoneProps {
  children: ReactNode;
  onDrop?: (files: FileList) => void;
  disabled?: boolean;
  className?: string;
}

export function DropZone({ children, onDrop, disabled, className }: DropZoneProps) {
  const composer = useChatComposer();
  const isStreaming = useChatIsStreaming();

  const handleDrop = (files: FileList) => {
    if (onDrop) {
      onDrop(files);
    } else {
      composer.addFiles(files);
    }
  };

  return (
    <BaseDropZone onDrop={handleDrop} disabled={disabled ?? isStreaming} className={className}>
      {children}
    </BaseDropZone>
  );
}
